import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PROCESS_STEPS, IMAGES } from "@/data/content";

export const Process = () => {
  return (
    <section id="ablauf" data-testid="process" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_0.9fr] lg:items-center lg:gap-16">
          <div>
            <Reveal>
              <span className="font-heading text-xs font-semibold uppercase tracking-[0.24em] text-brand-blue">
                Was ist Fahrzeugüberführung?
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-[3.4rem]">
                Du fährst Autos von A&nbsp;nach&nbsp;B – und wirst{" "}
                <span className="text-gradient-brand">dafür bezahlt.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-6 space-y-4 font-body text-base leading-relaxed text-white/70 sm:text-lg">
                <p>
                  Autohäuser, Autovermietungen, Leasinggesellschaften, Flottenbetreiber und andere
                  Unternehmen müssen täglich Fahrzeuge von einem Standort zu einem anderen
                  transportieren. Dafür werden Fahrer benötigt.
                </p>
                <p>
                  Als Fahrzeugüberführer übernimmst du einen Auftrag, holst ein Fahrzeug am
                  vereinbarten Standort ab und bringst es zum Zielort.
                </p>
                <p className="text-white/90">
                  Das Spannende daran: Du kannst selbst entscheiden, welche passenden Aufträge du
                  annimmst und wann du fahren möchtest.
                </p>
                <p className="text-white/90">
                  Und weil überall in Deutschland Fahrzeuge bewegt werden müssen, kannst du{" "}
                  <span className="font-semibold text-brand-green">deutschlandweit</span> fahren –
                  du bist an keine Region gebunden.
                </p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="relative">
              <div className="overflow-hidden rounded-3xl border border-white/10">
                <img src={IMAGES.handover} alt="Fahrzeugübergabe – Schlüsselübergabe" className="aspect-[4/5] w-full object-cover" />
              </div>
              <div className="absolute -bottom-5 -left-3 rounded-2xl glass px-5 py-4 sm:-left-6">
                <p className="font-heading text-3xl font-extrabold text-brand-green sm:text-4xl">A → B</p>
                <p className="font-body text-xs text-white/60">Übernahme & Ablieferung</p>
              </div>
            </div>
          </Reveal>
        </div>

        {/* 3-step process */}
        <div className="mt-20 grid grid-cols-1 gap-5 md:grid-cols-3 lg:mt-28">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.1}>
              <div className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-brand-surface p-7 transition-colors duration-300 hover:border-brand-green/40">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-5xl font-extrabold text-white/10 transition-colors duration-300 group-hover:text-brand-green/30">
                    {step.num}
                  </span>
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-green/10 text-brand-green">
                    <step.icon className="h-6 w-6" />
                  </div>
                </div>
                <h3 className="mt-6 font-heading text-xl font-bold text-white">{step.title}</h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-white/60">{step.text}</p>
                {i < PROCESS_STEPS.length - 1 && (
                  <ArrowRight className="absolute -right-3 top-1/2 hidden h-6 w-6 -translate-y-1/2 text-brand-green/50 md:block" />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
